module.exports = __webpack_public_path__ + "66b74d488b48f6f883aedcaf0d0bbc7f.svg";